namespace $.$$ {
	export class $shm_hitalama_guide_repository extends $.$shm_hitalama_guide_repository {
		editable() { return this.catalog().can_change() }
		repository( next?: string ) { return this.catalog().Github_repository( next === undefined ? undefined : null )?.val( next === undefined ? undefined : next.trim() ) || 'hitalama/hitalama-docs' }
		@ $mol_mem
		github() { return new this.$.$shm_hitalama_guide_github }
		@ $mol_mem
		revision( next = 0 ) { return next }
		@ $mol_mem
		remote() { return $mol_wire_sync( this.github() ).read_optional( this.$.$shm_hitalama_components_github.repository( this.repository() ), this.$.$shm_hitalama_settings.github_token(), this.revision() ) }
		snapshot() { return JSON.stringify( this.$.$shm_hitalama_guide_github.catalogue_files( this.catalog() ) ) }
		@ $mol_mem
		changes() { const diff = $mol_wire_sync( this.github() ).changes( this.$.$shm_hitalama_components_github.repository( this.repository() ), this.$.$shm_hitalama_settings.github_token(), this.snapshot(), this.remote() ); return [ ...diff.changed, ...diff.removed ] }
		status() { const changes = this.changes(); return !this.remote() ? 'При первом коммите будет создан закрытый репозиторий.' : changes.length ? 'Есть новые изменения: ' + changes.length + ' файлов.' : 'На GitHub актуальная версия.' }
		commit_enabled() { return this.$.$mol_error_fence( ()=> this.editable() && this.changes().length > 0, ()=> false ) }
		sync_state() { return this.$.$mol_error_fence( ()=> this.changes().length ? 'active' : 'success', ()=> 'error' ) }
		@ $mol_action
		refresh( event?: Event ) { if( event ) this.revision( this.revision() + 1 ); return null }
		@ $mol_action
		close( event?: Event ) { if( event ) this.opened( false ); return null }
		private requests = new WeakMap<Event, { repository: string, token: string, snapshot: string, head: string | null }>()
		request( event: Event ) {
			let request = this.requests.get( event )
			if( !request ) { const remote = this.remote(); request = { repository: this.$.$shm_hitalama_components_github.repository( this.repository() ), token: this.$.$shm_hitalama_settings.github_token(), snapshot: this.snapshot(), head: remote?.head ?? null }; this.requests.set( event, request ) }
			return request
		}
		@ $mol_action
		commit( event?: Event ) {
			if( !event || !this.editable() ) return null
			const request = $mol_wire_sync( this ).request( event )
			$mol_wire_sync( this.github() ).save( request.repository, request.token, request.snapshot, request.head )
			this.catalog().Github_repository( null )!.val( request.repository ); this.revision( this.revision() + 1 )
			return null
		}
	}
}
